import { z } from 'zod';

/** IM-ADR-029: estados semânticos de uma informação; ausência nunca é confirmação. */
export const EVIDENCE_INFORMATION_STATES = [
  'CONFIRMADA',
  'DECLARADA',
  'INFERIDA',
  'CONFLITANTE',
  'INDISPONIVEL',
] as const;
export type EvidenceInformationState = (typeof EVIDENCE_INFORMATION_STATES)[number];

export const EVIDENCE_NATURES = ['FATO', 'INDICIO', 'HIPOTESE', 'DEDUCAO'] as const;
export type EvidenceNature = (typeof EVIDENCE_NATURES)[number];

export const EvidenceRefSchema = z.object({
  id: z.string().uuid(),
  title: z.string().min(1).nullable(),
  origin: z.enum(['AUTOMATICA', 'HUMANA']).nullable(),
  module: z.string().min(1).nullable(),
  sourceId: z.string().uuid().nullable(),
  sourceName: z.string().min(1).nullable(),
  url: z.string().url().nullable(),
  collectedAt: z.iso.datetime().nullable(),
  publishedAt: z.iso.datetime().nullable(),
  validUntil: z.iso.datetime().nullable(),
  nature: z.enum(EVIDENCE_NATURES).nullable(),
  confidence: z.enum(['ALTA', 'MEDIA', 'BAIXA']).nullable(),
  factId: z.string().min(1).nullable(),
  informationState: z.enum(EVIDENCE_INFORMATION_STATES),
  contradictory: z.boolean(),
  verification: z.string().min(1).nullable(),
  availability: z.enum(['NAO_VERIFICADA', 'DISPONIVEL', 'INDISPONIVEL']).nullable(),
}).strict().superRefine((ref, ctx) => {
  if (ref.informationState === 'INDISPONIVEL') {
    if (ref.title !== null || ref.nature !== null || ref.confidence !== null) {
      ctx.addIssue({ code: 'custom', message: 'Referência indisponível não pode inventar conteúdo.' });
    }
    return;
  }
  if (ref.title === null || ref.nature === null || ref.collectedAt === null) {
    ctx.addIssue({ code: 'custom', message: 'Evidência disponível exige título, natureza e data de coleta.' });
  }
  if (ref.informationState === 'CONFIRMADA' && !ref.url && !ref.sourceId) {
    ctx.addIssue({ code: 'custom', message: 'Informação confirmada exige fonte verificável.' });
  }
  if (ref.informationState === 'CONFLITANTE' && !ref.contradictory) {
    ctx.addIssue({ code: 'custom', message: 'Informação conflitante deve permanecer marcada como contraditória.' });
  }
});

export type EvidenceRef = z.infer<typeof EvidenceRefSchema>;

/** Ordem de certeza, não de relevância. Indisponível fica sempre por último. */
export function evidenceNatureRank(nature: EvidenceNature | null): number {
  return nature === 'FATO' ? 0 : nature === 'INDICIO' ? 1 : nature === 'DEDUCAO' ? 2 : nature === 'HIPOTESE' ? 3 : 4;
}

